import { render, staticRenderFns } from "./person-transfer.vue?vue&type=template&id=6a03a8de&"
import script from "./person-transfer.vue?vue&type=script&lang=js&"
export * from "./person-transfer.vue?vue&type=script&lang=js&"
import style0 from "./person-transfer.vue?vue&type=style&index=0&id=6a03a8de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports